import $ from "jquery";

const AjaxHelper = function () {
    var apiUrl = 'api.php';
    var apiHeader = { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' };
    var service = {};

    service.factory = function ($scope, $http, $httpParamSerializerJQLike) {
        if (typeof $scope.ajaxExecCnt == "undefined") {
            $scope.ajaxExecCnt = 0;
        }

        $scope.ajaxCall = function (view, actionParameter, method, data, callbackSuccess, callbackError) {
            var url = apiUrl + '?view=' + view;

            if (actionParameter) {
                url = url + '&action=' + actionParameter;
            }

            var ajaxParameter = {
                url: url,
                method: 'POST',
                headers: apiHeader
            };
            if (method) {
                ajaxParameter.method = method;
            }
            if (data) {
                ajaxParameter.data = $httpParamSerializerJQLike(data);
            }

            $scope.ajaxExecCnt++;

            $http(ajaxParameter).then(function (response) {
                if (response && response.data.template_calculated_hash && typeof response.data.template_calculated_hash === 'string') {
                    $('#templateCalculatedHash').val(response.data.template_calculated_hash);
                }
                $scope.ajaxExecCnt--;
                if (callbackSuccess) {
                    callbackSuccess(response.data);
                }
            }).catch(function (err) {
                $scope.ajaxExecCnt--;
                console.log('ERR', err);

                if (callbackError) {
                    callbackError(err);
                }
            });

        };
    };

    return service;
};

export default AjaxHelper;